import { Client } from 'nice-grpc-web';
import { GrpcClientFactoryType } from './types';
import {
  DeepPartial,
  ListModemsRequest,
  ListModemsRequest_Response,
  ModemServiceDefinition,
  TagCount_Request,
  TagCount_Response,
} from '../customer_compiled/modem';

export default class ModemService {
  private static instance: ModemService;
  private readonly client: Client<typeof ModemServiceDefinition>;

  private constructor(grpcClientFactory: GrpcClientFactoryType) {
    this.client = grpcClientFactory<typeof ModemServiceDefinition>(ModemServiceDefinition);
  }

  static getInstance(grpcClientFactory: GrpcClientFactoryType) {
    if (!ModemService.instance) {
      ModemService.instance = new ModemService(grpcClientFactory);
    }

    return ModemService.instance;
  }

  list(payload: DeepPartial<ListModemsRequest>): Promise<ListModemsRequest_Response> {
    const request = ListModemsRequest.fromPartial(payload);
    return this.client.list(request);
  }

  tagCount(payload: DeepPartial<TagCount_Request>): Promise<TagCount_Response> {
    const request = TagCount_Request.fromPartial(payload);
    return this.client.tagCount(request);
  }
}
